import React, { useState, useEffect, useMemo } from 'react';
import { apiHolder, reDefinedColorList } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import '../MailTag.scss';
import { useAppSelector } from '@web-common/state/createStore';
import AddSvg from './icon/AddSvg';
import DeleteSvg from './icon/DeleteSvg';
import { MailTagIcon } from '../../MailTagList/Icon';
import { getTreeStatesByAccount, isLockTag } from '../../../util';
import { getIn18Text } from 'api';
import { formatHotKey } from '@web-mail/util';
const systemApi = apiHolder.api.getSystemApi();
const eventApi = apiHolder.api.getEventApi();
var TAG_STATUS;
(function (TAG_STATUS) {
    TAG_STATUS["CHECKED"] = "CHECKED";
    TAG_STATUS["NONE"] = "NONE";
    TAG_STATUS["INDETERMINATE"] = "INDETERMINATE";
})(TAG_STATUS || (TAG_STATUS = {}));
const Menu = props => {
    const { mailList, Close, onChange, account } = props;
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const mailTagList = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap, account || '');
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList.filter(item => !isLockTag(item[0]));
        }
        return [];
    }, [mailTreeStateMap, account]);
    const { pathname } = window.location;
    const [tagStateMap, setTagStateMap] = useState({});
    useEffect(() => {
        const map = {};
        if (mailTagList && mailTagList.length) {
            mailTagList.map(item => {
                map[item[0]] = TAG_STATUS.NONE;
            });
        }
        if (mailList && mailList.length) {
            const tagMap = {};
            const max = mailList.length;
            mailList === null || mailList === void 0 ? void 0 : mailList.forEach(item => {
                let tags = (item === null || item === void 0 ? void 0 : item.tags) || [];
                tags = Array.from(new Set(tags));
                tags === null || tags === void 0 ? void 0 : tags.forEach(tag => {
                    tagMap[tag] ? (tagMap[tag] += 1) : (tagMap[tag] = 1);
                });
            });
            for (const [key, value] of Object.entries(tagMap)) {
                map[key] = value === max ? TAG_STATUS.CHECKED : TAG_STATUS.INDETERMINATE;
            }
        }
        setTagStateMap(map);
    }, [mailList, mailTagList]);
    const handleChange = params => {
        onChange && onChange(params);
    };
    const getAllMialList = list => {
        const res = [];
        list.forEach(_ => {
            res.push(_.entry.id);
        });
        return res;
    };
    const handleCheckboxChange = (checked, tagName, tagId) => {
        const map = Object.assign({}, tagStateMap);
        if (checked) {
            message.loading({ content: getIn18Text('BIAOJIZHONG'), duration: 35, key: tagName });
            eventApi.sendSysEvent({
                eventName: 'mailTagChanged',
                eventData: {
                    tagNames: [tagName],
                    mailList: mailList.map(_ => _.entry.id),
                    tagIds: [tagId],
                },
                eventStrData: 'tag',
                _account: account,
            });
            map[tagName] = 1;
            handleChange({
                eventName: 'mailTagChanged',
                eventStrData: 'tag',
                _account: account,
            });
        }
        else {
            message.loading({ content: getIn18Text('QUXIAOBIAOJIZHONG'), duration: 35, key: tagName });
            eventApi.sendSysEvent({
                eventName: 'mailTagChanged',
                eventData: {
                    tagNames: [tagName],
                    mailList: mailList.map(_ => _.entry.id),
                    tagIds: [tagId],
                },
                eventStrData: 'untag',
                _account: account,
            });
            map[tagName] = 0;
            handleChange({
                eventName: 'mailTagChanged',
                eventStrData: 'untag',
                _account: account,
            });
        }
        setTagStateMap(map);
        handleClose();
    };
    const handleClearAllTag = () => {
        const tagNames = mailTagList.filter(item => [TAG_STATUS.CHECKED, TAG_STATUS.INDETERMINATE].includes(tagStateMap[item[0]])).map(item => item[0]);
        if (tagNames.length <= 0) {
            return;
        }
        const key = tagNames.join(',');
        message.loading({ content: getIn18Text('BIAOJIQINGCHUZHONG'), duration: 35, key });
        eventApi.sendSysEvent({
            eventName: 'mailTagChanged',
            eventData: {
                tagNames,
                mailList: mailList.map(_ => _.entry.id),
                successMsg: getIn18Text('QINGKONGYIYOUBIAO11'),
                failMsg: getIn18Text('QINGKONGYIYOUBIAO'),
            },
            eventStrData: 'untag',
            _account: account,
        });
        handleChange({
            eventName: 'mailTagChanged',
            eventStrData: 'clearAllTag',
            _account: account,
        });
        handleClose();
    };
    const handleAddTag = () => {
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventData: {
                tagNames: [],
                mailList: mailList.map(_ => _.entry.id),
            },
            eventStrData: 'addTagAndMark',
            _account: account,
        });
        handleChange({
            eventName: 'mailTagChanged',
            eventStrData: 'addTag',
            _account: account,
        });
        handleClose();
    };
    const handleClose = () => {
        Close && Close();
    };
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const mailTagHotKeysMap = useAppSelector(state => state.hotKeyReducer.mailTagHotKeysMap);
    const tag2HkMap = useMemo(() => {
        var _a;
        try {
            const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account;
            if (accountKey) {
                return mailTagHotKeysMap[accountKey] || {};
            }
        }
        catch (e) {
            console.error('[error] mailtagHotKey error read local', e);
        }
        return {};
    }, [mailTagHotKeysMap, account]);
    return (React.createElement("div", { className: "mt-footer-menu-wrap extheme" },
        mailTagList && mailTagList.length ? (React.createElement("div", { className: "mt-list" }, mailTagList.map(item => {
            const status = tagStateMap[item[0]];
            const strokeColor = reDefinedColorList.find(innerItem => { var _a; return innerItem.nums.includes((_a = item[1]) === null || _a === void 0 ? void 0 : _a.color); });
            const colorClassName = (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.className) || 'color1';
            return (React.createElement("div", { className: "mt-item", "data-test-id": 'menu-tag-name-' + item[0], onClick: e => {
                    e.stopPropagation();
                    const { tagId } = item[1];
                    handleCheckboxChange(status !== TAG_STATUS.CHECKED, item[0], tagId);
                } },
                React.createElement("div", { className: "mt-oper-wrap" },
                    React.createElement(MailTagIcon, { className: "tag-icon", strokeColor: strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.color, checked: status === TAG_STATUS.CHECKED })),
                React.createElement("div", { className: "mt-content-warp", "data-test-id": `menu-tag-name-${item[0]}`, title: item[0] + (tag2HkMap[item[0]] ? ', ' + formatHotKey(tag2HkMap[item[0]]) : '') }, item[0]),
                React.createElement("div", { className: "mt-content-hotkey" }, tag2HkMap[item[0]] ? formatHotKey(tag2HkMap[item[0]]) : '')));
        }))) : (React.createElement("div", { className: "mt-none" }, getIn18Text('ZANWUBIAOQIAN'))),
        React.createElement("div", { className: "mt-line" }),
        React.createElement("div", { className: "mt-footer-btns" },
            !pathname.includes('readMailComb') && (React.createElement("div", { className: "mt-item", "data-test-id": "menu-tag-create-button", onClick: handleAddTag },
                React.createElement("div", { className: "mt-oper-wrap" },
                    React.createElement(AddSvg, { className: "add-svg" })),
                React.createElement("div", { className: "mt-content-warp", "data-test-id": "menu-tag-create-button" }, getIn18Text('XINJIANBIAOQIANBING')))),
            mailTagList && mailTagList.length ? (React.createElement("div", { className: "mt-item", "data-test-id": "menu-tag-clean-button", onClick: handleClearAllTag },
                React.createElement("div", { className: "mt-oper-wrap" },
                    React.createElement(DeleteSvg, { className: "delete-svg" })),
                React.createElement("div", { className: "mt-content-warp", "data-test-id": "menu-tag-clean-button" }, getIn18Text('QINGKONGYIYOUDE')))) : (''))));
};
export default Menu;
